import React from 'react'
import { scaleDown as BurgerMenu } from 'react-burger-menu'
import styled from 'styled-components'
import { Link } from 'gatsby'
import MenuLogo from '../fonts/logo.svg'
import SearchLogo from '../fonts/search.svg'
import { useState } from "react"
// import { useEffect, useLayoutEffect } from 'react';
import { navigate } from "gatsby"


//import AniLink from "gatsby-plugin-transition-link/AniLink"

const StyledBurgerMenu = styled.div`
    @media only screen and (min-width: 1024px) {
        visibility: hidden
    }

    // &>div {
    //   right: -100%;
    // }

    .bm-item {
        display: inline-block;
        text-decoration: none;
        margin-bottom: 1vw;
        color: #ffffff;
        font-family: "aktiv-grotesk",serif;
        font-size: 22px;
        font-weight: 800;
        vertical-align: middle;
        letter-spacing: -0.4px;
        transition: color 0.2s;
        text-align: left;
        color: #ffffff;
    }

    .bm-item:hover {
        color: white;
    }

    .bm-burger-button {
        position: fixed;
        color: #ffffff;
        width: 7vw;
        height: 5vw;
        right: 4vw;
        top: 2.7vh;
        display: none;
    }
    .bm-burger-bars {
        background: #ffffff;
    }
    .bm-cross-button {
        height: 80px;
        width: 80px;
        right: 14px !important;
        top: 14px !important;
        background-size: cover;
        background-image: url("/img/close.png");
        background-repeat: no-repeat;
        background-position: center center;
        span {
          display: none;
        }
    }
    .bm-cross {
        background: #bdc3c7;
    }
    .bm-menu {
        z-index: 9999;
        margin: auto;
        background: #17102B;
        padding: em 0em 0 0;
        font-size: 2em;
    }
    .bm-morph-shape {
        fill: #373a47;
    }
    .bm-item-list {
        color: #b8b7ad;
    }

    .bm-overlay {
        background: rgba(0, 0, 0, 0);
        top: 0px;
        // right: -100%;
    }
    #burger_menu.bm-menu-wrap {
      top: 0px;
      // right: -100%;
    }
`

const Logo = styled.img`
    width: 50vw;
    margin-top: 3vw;
    margin-left: 4vw;
    display: block;
`

// width: 50vw;
// margin-top: 3vw;
// margin-left: 4vw;

const StyleDiv = styled.div`
  display:inline;
  margin-right: 2vh;
  height: 55px;
  width: 6px;
  float: left;
`

// const StyleDivLink = styled.div`
//   display:inline;
// `

const LineHorizontal = styled.div`
  box-sizing: border-box;
  background: #2C333F;
  height: 1px;
  width: 95%;
  margin: auto;
`

const SIDEBAR = () => {
  // i don't know why but the state of menu open is the opposite of what i expect
  const [isMenuOpen, setMenuOpenState] = useState(false);
  const [searchQ, setSearchQ] = useState('');

  const close_menu = () => {
    // debugger;
    setMenuOpenState(false);
  };

  function handleStateChange (state) {
    setMenuOpenState(state.isOpen);
  }

  // if (isMenuOpen) {
  //   close_menu();
  // }

  return (
    <StyledBurgerMenu id="outer_burger">
      {/* {isMenuOpen + ''} */}
      <BurgerMenu
        id="burger_menu"
        width="100%"
        disableAutoFocus
        style={{ visibility: "hidden" }}
        onStateChange={handleStateChange}
        right
        isOpen={isMenuOpen}
      >
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darkslateblue"
          hex="#17102B"
          duration={0.5}
          to="/"
          rel="home"
        >
          <Logo src={MenuLogo} alt={"Menu"} />
        </Link>
        {/* <LineHorizontal style={{marginTop:'18px'}}>
        &nbsp;
      </LineHorizontal> */}
        <div
          style={{
            color: "#FFFFFF",
            opacity: "1",
            fontSize: "19px",
            margin: "15px",
          }}
        >
          <div className="gcse-search"></div>
        </div>
        <LineHorizontal>&nbsp;</LineHorizontal>
        <StyleDiv style={{ background: "#FF0000" }}></StyleDiv>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            className="search-input"
            placeholder={"Cerca..."}
            style={{
              height: "55px",
              paddingTop: "8px",
              flex: 5,
              background: "transparent",
              outline: "none",
              boxShadow: "none",
              border: "none",
              fontFamily: "aktiv-grotesk",
              fontSize: "19px",
              letterSpacing: "-0.4px",
              lineHeight: "25px",
              color: "white",
            }}
            onChange={(e) => setSearchQ(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                navigate(`/search?s=${searchQ}`);
                close_menu();
              }
            }}
          />
          <div
            onClick={() => {
              navigate(`/search?s=${searchQ}`);
              close_menu();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Space") {
                navigate(`/search?s=${searchQ}`);
                close_menu();
              }
            }}
            role="button"
            tabIndex="0"
            style={{ paddingRight: "0.85rem" }}
          >
            <img src={SearchLogo} style={{ flex: 1 }} alt={"Search"} />
          </div>
        </div>
        <LineHorizontal>&nbsp;</LineHorizontal>
        <div
          style={{
            color: "#FFFFFF",
            opacity: "0.37",
            fontSize: "12px",
            margin: "10px",
          }}
        >
          MY
        </div>
        <StyleDiv></StyleDiv>
        <div id="intro_mobile_step2" style={{ display: "none" }} />
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <Link
            className="bm-item"
            onClick={close_menu}
            style={{
              color: "white",
              height: "55px",
              paddingTop: "8px",
              float: "left",
              // width:"60%",
              fontSize: "18px",
            }}
            to="/my"
          >
            Articoli Salvati
          </Link>
          <span
            style={{
              color: "white",
              height: "55px",
              paddingTop: "8px",
              // float: "left",
              // width:"60%",
              fontSize: "18px",
              display: "none",
            }}
          >
            |
          </span>
          <Link
            className="bm-item"
            onClick={() => {
              close_menu();
            }}
            style={{
              color: "white",
              height: "55px",
              paddingTop: "8px",
              paddingRight: "1rem",
              float: "right",
              // width:"30%",
              fontSize: "18px",
            }}
            to="/option"
          >
            Impostazioni
          </Link>
        </div>
        <LineHorizontal>&nbsp;</LineHorizontal>
        {/* <div style={{color:'#FFFFFF',opacity: "0.37",fontSize: "12px", margin: "10px"}}>TOPIC</div> */}
        <StyleDiv
          style={{
            background:
              "linear-gradient(53.35deg, rgb(238, 61, 73) 0%, rgb(203, 53, 107) 100%)",
          }}
        ></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/life/"
        >
          Life
        </Link>
        <StyleDiv
          style={{
            background:
              "linear-gradient(53.35deg, rgb(238, 61, 73) 0%, rgb(203, 53, 107) 100%)",
          }}
        ></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/valoreresponsabile/"
        >
          Valore Responsabile
        </Link>
        <StyleDiv
          style={{
            background:
              "linear-gradient(53.35deg, rgb(238, 61, 73) 0%, rgb(203, 53, 107) 100%)",
          }}
        ></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/smartmoney/"
        >
          Smart Money
        </Link>
        <LineHorizontal>&nbsp;</LineHorizontal>
        <StyleDiv style={{ background: "#E5CB52" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="yellow"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/economy/"
        >
          Economy
        </Link>
        <StyleDiv style={{ background: "#EF767E" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darksalmon"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/education/"
        >
          Education
        </Link>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="mediumpurple"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/impact/"
        >
          Impact
        </Link>
        <StyleDiv style={{ background: "#43BDCC" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="cadetblue"
          bg="white"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/lifestyle/"
        >
          Lifestyle
        </Link>
        <StyleDiv style={{ background: "#39CD62" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="green"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/startup/"
        >
          Startup
        </Link>
        <StyleDiv style={{ background: "#D2227B" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="violetred"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/tech/"
        >
          Tech
        </Link>
        <LineHorizontal>&nbsp;</LineHorizontal>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darkslateblue"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="https://startupitaliaopensummit.eu/"
          target="_blank"
        >
          SIOS21
        </Link>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darkslateblue"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="https://shopping.startupitalia.eu/"
          target="_blank"
        >
          Shopping
        </Link>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darkslateblue"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/agenda/"
        >
          Agenda
        </Link>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darkslateblue"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/bandi/"
        >
          Bandi
        </Link>
        <LineHorizontal>&nbsp;</LineHorizontal>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darkslateblue"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/unstoppablewomen/"
        >
          Unstoppable Women
        </Link>
        {/*<StyleDiv style={{background:'#7F8CD1'}}></StyleDiv><Link style={{height:"55px",paddingTop:"0px"}} to='/category/unstoppable-women/'>#UnstoppableWomen</Link>*/}
        {/*<StyleDiv style={{display: "none", background:'#7F8CD1'}}></StyleDiv><Link onClick={ () =>{ close_menu();  }} style={{height:"55px",paddingTop:"0px"}} to='/humanize/'>#Humanize</Link>
      <StyleDiv style={{display: "none", background:'#7F8CD1'}}></StyleDiv><Link onClick={ () =>{ close_menu();  }} style={{height:"55px",paddingTop:"0px"}} to='/lowres/'>#LowRes</Link>
      <StyleDiv style={{background:'#7F8CD1',display:"none"}}></StyleDiv><Link onClick={ () =>{ close_menu();  }} style={{height:"55px",paddingTop:"0px",display:"none"}} to='/'>#LegalMentorship</Link>*/}
        <LineHorizontal>&nbsp;</LineHorizontal>
        <div
          style={{
            color: "#FFFFFF",
            opacity: "0.37",
            fontSize: "12px",
            margin: "10px",
          }}
        >
          STARTUPITALIA
        </div>
        <StyleDiv style={{ background: "#7F8CD1", display: "none" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          style={{ height: "55px", paddingTop: "8px", display: "none" }}
          to="/"
        >
          Lavora con noi
        </Link>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          style={{ height: "55px", paddingTop: "8px" }}
          to="/about-us/"
        >
          Advisory Board
        </Link>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <a
          href={"https://investor.startupitalia.eu/"}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            close_menu();
          }}
          style={{ height: "55px", paddingTop: "8px", color: "inherit" }}
        >
          Area Investor
        </a>
        <StyleDiv style={{ background: "#7F8CD1", display: "none" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          style={{ height: "55px", paddingTop: "8px", display: "none" }}
          to="/"
        >
          I nostri autori
        </Link>
        <StyleDiv style={{ background: "#7F8CD1" }}></StyleDiv>
        <Link
          onClick={() => {
            close_menu();
          }}
          color="darkslateblue"
          hex="#17102B"
          duration={0.4}
          style={{ height: "55px", paddingTop: "0px" }}
          to="/lavora-con-noi/"
        >
          Lavora con noi
        </Link>
      </BurgerMenu>
    </StyledBurgerMenu>
  );
}

export default SIDEBAR
